<div class="view-component">
    <div class="view-component-title">
        <span class="title">Tabela de De/Para</span>
    </div>
    <div class="content">
        <simple-datagrid entityName="Mktpfromtodata" [parentRow]="parentRow" [condition]="condition" nodata="true" [events]="eventsSubject.asObservable()"></simple-datagrid>
    </div>
</div> 